<template>
  <div class="container">
    <VasionInput
      v-model="field"
      title="Field"
      inputType="top-white"
      required
    />
    <p v-for="index in 30" :key="index" value="TEST">
      {{ `Testing TAB Container ${index}` }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'PackageTabRules',
  data: function () {
    return {
      field: ''
    }
  },
}
</script>
<style lang="scss" scoped></style>
